import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

export const useCategoryFormLogic = (category?: any) => {
  const [selectedCategory, setSelectedCategory] = useState<any>(
    category?.parentCategoryId || ""
  );
  const [parentSelectedCategory, setParentSelectedCategory] = useState<any>("");

  const defaultCategoryValues = {
    ...category,
    id: category?.id || null,
    title: category?.title || null,
    categories: category?.categories || null,
  };

  const form = useForm({
    mode: "onChange",
    defaultValues: defaultCategoryValues,
  });

  // Effect to handle category selection changes
  useEffect(() => {
    form.setValue("category", selectedCategory, { shouldValidate: true });
  }, [selectedCategory, form]);

  return {
    form,
    selectedCategory,
    setSelectedCategory,
    parentSelectedCategory,
    setParentSelectedCategory,
  };
};
